"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLink = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const FLink = ({ title, path = "", variant = "primary", className = "", onClick = () => { }, prefix, postfix, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_router_dom_1.Link, { to: `/${path}`, className: `f-link f-link-${variant} ${className}`, onClick: (e) => {
                e.preventDefault();
                onClick();
            } },
            prefix && react_1.default.createElement("span", { className: "f-btn-icon" }, prefix),
            title,
            postfix && react_1.default.createElement("span", { className: "f-btn-icon" }, postfix))));
};
exports.FLink = FLink;
//# sourceMappingURL=Flink.js.map